import { createContext, useContext, useState } from 'react';

const ConfirmContext = createContext(null);

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) throw new Error('useConfirm debe usarse dentro de ConfirmProvider');
  return context;
};

export const ConfirmProvider = ({ children }) => {
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    type: 'danger',
    onConfirm: () => {},
    onCancel: () => {}
  });

  const confirm = ({ title, message, confirmText, cancelText, type = 'danger' }) => {
    return new Promise((resolve) => {
      setConfirmState({
        isOpen: true,
        title,
        message,
        confirmText: confirmText || 'Confirmar',
        cancelText: cancelText || 'Cancelar',
        type,
        onConfirm: () => {
          setConfirmState(prev => ({ ...prev, isOpen: false }));
          resolve(true);
        },
        onCancel: () => {
          setConfirmState(prev => ({ ...prev, isOpen: false }));
          resolve(false);
        }
      });
    });
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {confirmState.isOpen && (
        <div className="modal-overlay" onClick={confirmState.onCancel}>
          <div className="modal confirm-modal" onClick={e => e.stopPropagation()}>
            <div className={`confirm-icon confirm-icon-${confirmState.type}`}>
              <i className={`fa-solid ${
                confirmState.type === 'danger' ? 'fa-trash' :
                confirmState.type === 'warning' ? 'fa-exclamation-triangle' :
                'fa-question-circle'
              }`}></i>
            </div>
            <h4 className="confirm-title">{confirmState.title}</h4>
            <p className="confirm-message">{confirmState.message}</p>
            <div className="confirm-actions">
              <button className="btn btn-ghost" onClick={confirmState.onCancel}>
                {confirmState.cancelText}
              </button>
              <button
                className={`btn ${confirmState.type === 'danger' ? 'btn-danger' : 'btn-primary'}`}
                onClick={confirmState.onConfirm}
              >
                {confirmState.confirmText}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

export default ConfirmContext;
